import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from '../components/AvatarDropdown';
import styles from './index.module.less';
import { BroadcastChannel } from 'broadcast-channel';
import { request } from '@/shared/io';
import { getApiUrl } from '@/shared/utils';
import { useSharedGlobalState } from '@/shared/hooks';
import { useEffect, useState } from 'react';
const changeNameBc = new BroadcastChannel('changeNameBc');
export const IIPHeader = ({}) => {
    const [renderFlag, setRenderFlag] = useState(Math.random());
    const { authLoginType, _initStateByKey } = useSharedGlobalState();
    useEffect(() => {
        changeNameBc.addEventListener('message', () => {
            setRenderFlag(Math.random());
        });
    }, []);
    useEffect(() => {
        request(`${getApiUrl(authLoginType)}/api/uims/v1/org/my`).then(({ code, data }) => {
            if (code === 200) {
                _initStateByKey('orgMyUserInfoType', data);
            }
        });
    }, [renderFlag]);
    return (_jsxs("header", { className: styles.header, children: [_jsx("div", { className: styles.headerLeft, children: _jsx("span", { className: styles.systemName, children: "\u57FA\u5EFA\u5DE5\u7A0B\u4EA7\u4E1A\u4E92\u8054\u7F51\u670D\u52A1\u4E00\u4F53\u5316\u5E73\u53F0" }) }), _jsx("div", { className: styles.headerRight, children: _jsx(Avatar, { showMenu: true, noBase: true }) })] }));
};
